import { useUser } from '@folklore/auth';
import { StaticRouter } from '@folklore/routes';
import { useEffect } from 'react';
import { useLocation, useSearch } from 'wouter';

import usePage from '../hooks/usePage';
import { getComponentFromName } from '../lib/utils';

import { ThemeProvider } from '../contexts/ThemeContext';
import PageRoutes from './Routes';
import * as Layouts from './layouts/index';

// import Page from './pages/Page';
import '../../styles/styles.css';

function App() {
    useEffect(() => {
        if (window.history.scrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    const [location] = useLocation();
    const search = useSearch();
    const {
        page = null,
        notFound,
        isFetching,
    } = usePage(location, {
        keepPreviousData: true,
    });

    const { theme: pageTheme, layout: pageLayout = null, url = null } = page || {};

    const Layout = getComponentFromName(Layouts, pageLayout, 'main');

    return (
        <ThemeProvider theme={pageTheme}>
            {page !== null ? (
                <StaticRouter location={isFetching ? url || '' : `${location}?${search}`}>
                    <Layout page={!notFound ? page : null} loading={isFetching}>
                        <StaticRouter location={isFetching ? url || '' : `${location}?${search}`}>
                            <PageRoutes />
                        </StaticRouter>
                    </Layout>
                </StaticRouter>
            ) : null}
        </ThemeProvider>
    );
}

export default App;
